import type { FC } from 'react';
import styles from '../styles/shop-card.module.scss';

const ShopCard: FC<{
    className?: string;
    header?: string;
    name: string;
    address: string;
    mapUrl: string;
    metroStation?: string;
    phone: string;
}> = ({ className = '', header, name, address, mapUrl, metroStation, phone }) => {
    return (
        <div className={`${styles.shopCard} ${className}`}>
            {header && <div className={styles.header}>{header}</div>}
            <div className={styles.shopName}>{name}</div>
            <div>所在地：{address}</div>
            <a href={mapUrl} target="_blank" rel="noopener noreferrer">
                詳細地図
            </a>
            <div className={styles.infoRow}>
                {metroStation && <span>最寄駅：{metroStation}</span>}
                <span>TEL：{phone}</span>
            </div>
        </div>
    );
};

export default ShopCard;
